export default function QuickAction({ title, description, onClick, bgColor, textColor, border }) {
  return (
    <button
      onClick={onClick}
      className={`p-4 rounded-xl text-left transition-all hover:shadow-md ${bgColor} ${textColor} ${
        border || ''
      }`}
    >
      <h3 className="font-semibold text-base mb-1">{title}</h3>
      <p className={`text-sm ${textColor === 'text-white' ? 'text-white/80' : 'text-gray-600'}`}>
        {description}
      </p>
    </button>
  )
}
